import React from "react";
import ArrayField from "../../../buildingBlocks/ArrayField";
import FormWrapper from "../../../buildingBlocks/FormWrapper";
import Contact from "./Contact";

export default function Depositors({ name }) {
  const tooltips = {
    contributor:
      "List of other people who contributed to generating the deposited data, metadata, results, or the deposition itself",
  };

  return (
    <>
      <div className="mb-3">
        <FormWrapper
          headline="Depositor"
          tooltip="The person who made the deposition to MBDB"
          name={name}
        >
          <Contact name={`${name}.depositor`} />
        </FormWrapper>
      </div>
      <div className="mb-3">
        <FormWrapper
          headline="Principal contact"
          tooltip="The person responsible for the record and the one to contact for inquiries, this would typically be the principle investigator, group leader, or laboratory head"
          name={`${name}.principal_contact`}
        >
          <Contact name={`${name}.principal_contact`} />
        </FormWrapper>
      </div>
      <ArrayField
        name={name}
        label="Contributor"
        fieldName="contributors"
        tooltip={tooltips.contributor}
        renderChild={({ arrayName, index }) => (
          <FormWrapper
            headline={`Contributor ${index + 1}`}
            tooltip={tooltips.contributor}
          >
            <Contact name={`${arrayName}.${index}`} />
          </FormWrapper>
        )}
      />
    </>
  );
}
